import { ActionTypes } from '../actions/types/api';
export const initialState = {
    data: null,
    initial: true,
    loading: false,
    error: null,
    statusOk: null,
    fromCache: false,
};
export const getInitialState = (data) => data
    ? {
        ...initialState,
        data,
        initial: false,
        statusOk: true,
        fromCache: true,
    }
    : initialState;
export const apiReducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.FetchStart:
            return {
                ...initialState,
                // Если данные уже были инициализированы, то флаг должен быть falsy, как в стейте
                initial: state.initial,
                fromCache: state.fromCache,
                loading: true,
            };
        case ActionTypes.FetchSuccess:
            return {
                ...initialState,
                initial: false,
                data: action.payload.response.data,
                statusOk: true,
                fromCache: action.payload.fromCache,
            };
        case ActionTypes.FetchFailure:
            return {
                ...state,
                loading: false,
                error: action.payload.error,
                statusOk: false,
            };
        case ActionTypes.ResetState:
            return {
                ...initialState,
            };
        default:
            return state;
    }
};
